// extracted by mini-css-extract-plugin
export default {"container":"CampaignBenefitsSection_container__Mbjr1"};